/* @flow weak */

'use strict';

const Reflux = require('reflux');
const { map, each, get, find } = require('lodash');
const Config = require('../configs/Config.js');
const Loader = require('../loaders');
const ln = Loader.ln || 'en_US';
const ValidatorActions = require('../actions/ValidatorActions.jsx');
const QuestionStore = require('../stores/QuestionStore.jsx');

import Constraints from '../constraints';

import { VALIDATOR_PRIORITY_MEDIUM } from '../constraints/ConstraintValidatorPriorities';

const ValidatorStore = Reflux.createStore({
  listenables: [ValidatorActions],

  validationData: {
    valid: null,
    questions: {},
    hasUserSubmitted: false,
    invalidQuestions: [],
    invalidGroups: []
  },

  constraintRegistry: [],

  getInitialState() {
    return this.validationData;
  },

  onLoad(questions) {
    each(questions, question => {
      each(question.constraints, (payload, constraintName) => {
        const constraintType = Constraints[constraintName];

        if (constraintType) {
          const priority = constraintType.validationPriority || VALIDATOR_PRIORITY_MEDIUM;

          if (!this.constraintRegistry[priority]) {
            this.constraintRegistry[priority] = [];
          }

          this.constraintRegistry[priority].push({
            question,
            validator: constraintType.validate,
            payload: payload,
          });
        }
      });
    });

    this.trigger(this.validationData);
  },

  onValidateConfiguration(answers, specificQuestionGroup = null) {
    const { questions, invalidQuestions, invalidGroups } = this.validationData;

    // reset validation data
    this.validationData.valid = true;
    invalidQuestions.length = 0;
    invalidGroups.length = 0;
    each(questions, question => {
      question.messaging = [];
      question.valid = null;
    });

    // iterate over all registered constraints and build validation data accordingly
    each(this.constraintRegistry, constraints => {
      each(constraints, constraint => {
        const { question, validator, payload } = constraint;

        if (typeof validator === 'function') {
          const questionGroup = get(question, `metadata.lang.${ln}.QuestionGroup`) || 'Other';
          if (specificQuestionGroup == null || questionGroup == specificQuestionGroup) {

            const visible = !questions[question.id] || questions[question.id].visible !== false;
            const response = validator(question, visible, answers, payload, Config, ln);
            const questionName = get(question, `metadata.lang.${ln}.DisplayName`) || question.name;

            if (response.valid === false) {
              this.validationData.valid = false;
              invalidQuestions.push(questionName);

              if (invalidGroups.indexOf(questionGroup) === -1) {
                invalidGroups.push(questionGroup);
              }
            }

            const currentMessaging = get(questions[question.id], 'messaging') || [];
            var currentValid = get(questions[question.id], 'valid');
            const messaging = response.messaging ? [...currentMessaging, response.messaging] : currentMessaging;
            var valid = currentValid == false ? currentValid : response.valid;

            questions[question.id] = Object.assign(
              questions[question.id] || {},
              response,
              { messaging, valid: valid }
            );
          }
        }
      });
    });

    this.trigger(this.validationData);
  },

  onRegisterUserSubmission() {
    this.onDisplayValidation();
  },

  onDisplayValidation() {
    this.validationData.hasUserSubmitted = true;
    this.trigger(this.validationData);
  },

  getValidationData() {
    return this.validationData;
  },
});

module.exports = ValidatorStore;



// WEBPACK FOOTER //
// ./src/base/scripts/stores/ValidatorStore.jsx